import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { useFormatCurrency } from 'platform/locale';
import { isNil } from 'ramda';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type MoneyValue = {
  amount: number;
  currency: string;
} | null;
type MoneyCellRendererProps = CellRendererProps<MoneyValue> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
export function MoneyCellRenderer(props: MoneyCellRendererProps) {
  const className = getCellClassName(props.column);
  const formatCurrency = useFormatCurrency();
  const cellStyles = getStylesToRender(props) as CellStyle | undefined;
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
  if (isNil(props.value)) {
    return null;
  }
  const decimalPlaces = typeof props.column.rendererParams?.decimalPlaces === 'number' ? props.column.rendererParams.decimalPlaces : 2;
  const cellValue = formatCurrency(props.value.amount, props.value.currency, decimalPlaces);
  return <Tooltip {...tooltipProps} label={cellValue ?? undefined}>
      <div className={className}>
        <Text color={cellStyles?.textColor} noWrap={!props.column?.wrapText} size="small">
          {cellValue}
        </Text>
      </div>
    </Tooltip>;
}